export function onClickOutside(element, callback) {
    const handler = (event) => {
        const target = event.target;
        if (!element.contains(target)) {
            callback();
        }
    };
    window.addEventListener('click', handler);
    return {
        destroy() {
            window.removeEventListener('click', handler);
        },
    };
}
